const modalTypes={
    "large":"modal-lg",
    "small":"modal-sm",
}

export {
    modalTypes
}
